import { defaultProps } from 'recompose';

import AutocompleteBase from '@/components/AutocompleteBase';

import Autocomplete from './component';

export default defaultProps({ Component: AutocompleteBase })(Autocomplete);
